export const getTextFilterCounterServerSideText = (items = [], pagesCount: number, pageSize: number) => {
    const count = pagesCount > 1 ? `${pageSize * (pagesCount - 1)}+` : items.length + '';
    return count === '1' ? `1 match` : `${count} matches`;
};

export const getTextFilterCounterText = (count: number | undefined) => `${count} ${count === 1 ? 'match' : 'matches'}`;
